import { useTranslation } from 'react-i18next'
import FileUpload from '../../../components/ui/FileUpload'
import AttachmentTable, { type AttachmentTableRow } from '../../../components/ui/AttachmentTable'
import { GRANTS } from '../../../auth/grants'
import { fileExtension } from '../../../lib/fileSize'
import { DOCUMENT_ACCEPT } from '../../../lib/uploadAccept'

interface Props {
  files: File[]
  onChange: (files: File[]) => void
}

/**
 * Tutanak dokümanları bölümü (039, US2). Paylaşılan {@link FileUpload} (yalnız yükleyici; yerleşik listesi
 * kapalı) ile PDF/Word/Excel/PowerPoint/görsel seçilir (kabul listesi tek kaynak: `lib/uploadAccept`); seçilen dosyalar ortak {@link AttachmentTable} ile
 * <b>Ad · Tür · Boyut</b> + Sil olarak Toplantı Detay ile aynı biçimde listelenir (Reuse Mandate). Aynı
 * ad+boyut ikilisi FileUpload'ta tekilleştirilir. Kesin doğrulama backend'de. Dosyalar Yayınla/Kaydet'ten
 * sonra oluşturulan tutanağa iliştirilir.
 */
export default function DocumentsSection({ files, onChange }: Readonly<Props>) {
  const { t } = useTranslation()

  const rows: AttachmentTableRow[] = files.map((f) => ({
    key: `${f.name}:${f.size}`,
    fileName: f.name,
    extension: fileExtension(f.name),
    size: f.size,
  }))
  // FileUpload aynı ad+boyut ikilisini tekilleştirir → key benzersiz; kaldırma bu anahtarla güvenli.
  const removeRow = (row: AttachmentTableRow) =>
    onChange(files.filter((f) => `${f.name}:${f.size}` !== row.key))

  return (
    <section className="minutes-section">
      <div className="minutes-section-head">
        <h2>{t('minutes.documents.title')}</h2>
      </div>
      {/* Henüz yüklenmemiş yerel dosyalar (downloadId yok → İndir hiç render edilmez); yetki yine de
          bağlamla tutarlı verilir, dosyalar kaydedilince 'MEETING' ekine dönüşürler. */}
      <AttachmentTable rows={rows} onRemove={removeRow} requiredGrant={GRANTS.MEETING_FILE_DOWNLOAD} />
      <div className="mtg-doc-upload">
        <FileUpload
          files={files}
          onChange={onChange}
          showList={false}
          accept={DOCUMENT_ACCEPT}
          label={t('minutes.documents.add')}
          hint={t('minutes.documents.hint')}
        />
      </div>
    </section>
  )
}
